import { Component, computed, input, output, signal } from '@angular/core';

export interface CartItem {
  name: string;
  duration: number; // in minutes
  imageUrl?: string;
  providerName?: string;
  initials?: string;
}

@Component({
  selector: 'app-booking-cart',
  standalone: false,
  templateUrl: './booking-cart.component.html',
  styleUrls: ['./booking-cart.component.scss'],
})
export class BookingCartComponent {
  items = input<CartItem[]>([]);
  ctaLabel = input('Choose provider');
  mobileCtaLabel = input<string>();
  ctaDisabled = input(false);
  showBackButton = input(false);
  backLabel = input('Back');
  headerTitle = input('Your selection');
  scheduledDate = input<string>();
  scheduledTime = input<string>();
  showMakeChangesLink = input(false);
  warningMessage = input<string>();
  readOnly = input(false);

  ctaClick = output<void>();
  backClick = output<void>();
  removeItem = output<number>();
  makeChangesClick = output<void>();

  mobileExpanded = signal(false);

  totalDurationMinutes = computed(() =>
    this.items().reduce((sum, item) => sum + item.duration, 0)
  );

  totalHours = computed(() => Math.floor(this.totalDurationMinutes() / 60));

  totalMinutes = computed(() => this.totalDurationMinutes() % 60);

  isEmpty = computed(() => this.items().length === 0);

  toggleMobileExpand(): void {
    this.mobileExpanded.update((v) => !v);
  }

  onCtaClick(): void {
    this.ctaClick.emit();
  }

  onBackClick(): void {
    this.backClick.emit();
  }

  onRemoveItem(index: number): void {
    this.removeItem.emit(index);
  }
}
